module.exports = __webpack_public_path__ + "img/logo-hotelv-thelobby.1008fa85dfbe0cb4c34b42614548aed8.svg";